import { SEARCH_FORM } from '@location/model';
import { SEARCH_FORM_KEY } from '@location/constants';
import getPropFromModule from './getPropFromModule';

const { AREA_ID } = SEARCH_FORM_KEY;

const getSelectedAreaId = state =>
  getPropFromModule(state, SEARCH_FORM, AREA_ID);

export default getSelectedAreaId;
